import WaterMark from './WaterMark';

export type { WaterMarkProps } from './WaterMark';

export default WaterMark;
